import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface TimeSeriesDataPoint {
  date: string;
  total_bottles: number;
  unopened: number;
  opened: number;
  empty: number;
  whisky: number;
  wine: number;
  sake: number;
}

interface TimeSeriesChartProps {
  data: TimeSeriesDataPoint[];
}

export const TimeSeriesChart = ({ data }: TimeSeriesChartProps) => {
  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="total_bottles" stroke="#8884d8" name="総ボトル数" />
        <Line type="monotone" dataKey="unopened" stroke="#82ca9d" name="未開栓" />
        <Line type="monotone" dataKey="opened" stroke="#ffc658" name="開栓済み" />
        <Line type="monotone" dataKey="empty" stroke="#ff7c7c" name="空" />
      </LineChart>
    </ResponsiveContainer>
  );
};
